exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".file-upload__input{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/src?{}!./node_modules/sass-loader/lib/loader.js?sourcemap&outputStyle=expanded!./src/blocks/file-upload/file-upload.scss
// module id = 770
// module chunks = 0